export const buildQuery = (from, to) => {
  const fromQuery = `(min-width:${from}px)`;
  if (!to) {
    return fromQuery;
  }
  return `${fromQuery} and (max-width:${to}px)`;
};